import { useContext } from "react";
import { LocationContext } from "src/contexts/LocationContext";

export const useLocalLocation = () => {
   const context = useContext(LocationContext);
   if (!context) throw new Error('useLocalLocation must be used within LocationProvider');

   return context;
};